import React from 'react';
import { Car, Shield, FileText } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-border/50 bg-card/30 backdrop-blur-sm mt-20">
      <div className="container mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Car className="h-6 w-6 text-primary" />
              <span className="heading-font text-lg font-bold tracking-wider">VIN CHECK</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Fast and reliable VIN decoding powered by NHTSA official database.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4 text-sm uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  About
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4 text-sm uppercase tracking-wider">Legal</h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <Shield className="h-4 w-4 text-muted-foreground" />
                <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-muted-foreground" />
                <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-border/50 pt-8">
          <p className="text-center text-xs text-muted-foreground">
            © {new Date().getFullYear()} VIN Check. All rights reserved. Vehicle data provided by NHTSA.
          </p>
          <p className="text-center text-xs text-muted-foreground mt-2">
            <strong>Disclaimer:</strong> Information is provided as-is and should be verified independently.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
